import React, { useState } from 'react';

/**
 * A common hook to be used to control menu open/close
 * @returns State and handler for menu
 */
export default function useMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // handle click function for menu popup
  const handleMenuOpen: React.MouseEventHandler<HTMLButtonElement> = (
    event
  ) => {
    setAnchorEl(event.currentTarget);
    setIsMenuOpen(!isMenuOpen);
  };

  // handle close function for menu popup
  const handleMenuClose = () => {
    setAnchorEl(null);
    setIsMenuOpen(!isMenuOpen);
  };

  return { isMenuOpen, anchorEl, handleMenuOpen, handleMenuClose };
}
